import { WithRef } from '../../../types';
import IconBase, { CastProductIconProps, getStrokeWidth } from '../IconBase';

const DEFAULT_PRESET_BACKGROUND = '#243B45';

export const CastApa = ({
  ref,
  variant,
  color = 'currentColor',
  ...props
}: WithRef<SVGSVGElement, CastProductIconProps>) => {
  const strokeWidth = props.strokeWidth ?? getStrokeWidth(props.weight);
  const isPreset = variant === 'preset';
  const fill = isPreset
    ? props.fill ?? DEFAULT_PRESET_BACKGROUND
    : props.fill ?? 'none';
  const strokeColor = isPreset ? '#fff' : color;

  return (
    <IconBase
      ref={ref}
      {...props}
      color={color}
      viewBox="0 0 25 27"
      fill="none"
    >
      <path
        d="M24.2295 18.6685V8.33154C24.2295 7.20265 23.6273 6.15723 22.6474 5.59279L13.6958 0.423335C12.7179 -0.141112 11.5115 -0.141112 10.5337 0.423335L1.58206 5.59279C0.604212 6.15723 0 7.20265 0 8.33154V18.6685C0 19.7974 0.602225 20.8428 1.58206 21.4072L10.5337 26.5767C11.5115 27.1411 12.7179 27.1411 13.6958 26.5767L22.6474 21.4072C23.6253 20.8428 24.2295 19.7974 24.2295 18.6685Z"
        fill={fill}
      />
      <mask
        id="mask0_22307_26394"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="27"
      >
        <path
          d="M24.2295 18.6685V8.33154C24.2295 7.20265 23.6273 6.15723 22.6474 5.59279L13.6958 0.423335C12.7179 -0.141112 11.5115 -0.141112 10.5337 0.423335L1.58206 5.59279C0.604212 6.15723 0 7.20265 0 8.33154V18.6685C0 19.7974 0.602225 20.8428 1.58206 21.4072L10.5337 26.5767C11.5115 27.1411 12.7179 27.1411 13.6958 26.5767L22.6474 21.4072C23.6253 20.8428 24.2295 19.7974 24.2295 18.6685Z"
          fill={fill}
        />
      </mask>
      <g mask="url(#mask0_22307_26394)"></g>
      <path
        d="M15.2595 14.9536V12.2281C15.2595 12.0078 15.1357 11.805 14.9349 11.6948L12.4463 10.3321C12.2455 10.222 11.9979 10.222 11.7971 10.3321L9.30851 11.6948C9.10769 11.805 8.98389 12.0084 8.98389 12.2281V14.9536C8.98389 15.1739 9.10769 15.3767 9.30851 15.4869L11.7971 16.8496C11.9979 16.9597 12.2455 16.9597 12.4463 16.8496L14.9349 15.4869C15.1357 15.3767 15.2595 15.1733 15.2595 14.9536Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M18.4524 13.4655V20.1976"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M15.1729 8.32703L21.3187 11.6931"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M8.84229 8.45175L14.9882 5.08569"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M5.79077 13.7155V6.9834"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M9.07019 18.854L2.92432 15.4879"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M15.4016 18.7288L9.25513 22.0948"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </IconBase>
  );
};

CastApa.displayName = 'CastApa';
